import { render, staticRenderFns } from "./IchraBadge.vue?vue&type=template&id=2516ecb0&lang=pug"
import script from "./IchraBadge.vue?vue&type=script&lang=js"
export * from "./IchraBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports